import * as React from 'react';
import { ThreeDots } from 'react-loader-spinner';

function Loader() {
    return (
        <>
            <div style={{height:"fit-content", width:"fit-content", margin:"24% auto 0"}}>
                <ThreeDots
                    visible={true}
                    height="60"
                    width="60"
                    color="#1e621cff"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
            </div>
        </>
    )
}

export default Loader